import { Reducer } from '@reduxjs/toolkit'

import { PersonKnowledge } from '../util/PersonKnowledge'

 export const SET_KNOWLEDGE_LIST = 'SET_KNOWLEDGE_LIST'
 export const UPDATE_KNOWLEDGE_LIST= 'UPDATE_KNOWLEDGE_LIST'

interface SetKnowledgeList {
    type: typeof SET_KNOWLEDGE_LIST
    payload: {
        knowledgeArray: PersonKnowledge[]
    }
}

interface UpdateKnowledgeList {
    type: typeof UPDATE_KNOWLEDGE_LIST
    payload: {
        knowledgeArray: PersonKnowledge[]
    }
}

type ActionTypes = SetKnowledgeList | UpdateKnowledgeList

type State = {
    list?: PersonKnowledge[]
}

const initialState: State = {
  list: undefined,
}

export const knowledgeRequestReducer: Reducer<State, ActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case SET_KNOWLEDGE_LIST:
      return {
        ...state,
        list: action.payload.knowledgeArray,
      }
    case UPDATE_KNOWLEDGE_LIST:
      return {
        ...state,
        list: action.payload.knowledgeArray,
      }
    default:
      return state
  }
}
